import { render, staticRenderFns } from "./error.vue?vue&type=template&id=ae0ed138&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modules: require('/vercel/path0/components/Modules.vue').default,Footer: require('/vercel/path0/components/Footer.vue').default})
